var Vendd = (function (Vendd) {
    'use strict';

    var pending = false;
    var widgetModelPending = false;

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.GetModel, Vendd.ProductCompare, function (envelope) {

        if (pending === true) {
            return false;
        };

        pending = true;

        var options = {
            url: 'ProductCompareService.svc/GetProductCompareViewModel',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            model = response;

            Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.GetModelSuccess(model));

            pending = false;
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.Failed(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.GetWidgetModel, Vendd.ProductCompare, function (envelope) {

        if (widgetModelPending === true) {
            return false;
        };

        function onSuccess(response) {
            widgetModel = response ? $.extend({}, response, { LangCode: LhApp.Context.Language, CurrCode: LhApp.Context.Currency.Code }) : response;
            Vendd.ProductCompare.SetClientModel(widgetModel);
            Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.GetWidgetModelSuccess(widgetModel));

            widgetModelPending = false;
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.Failed(response));
        };

        var options = {
            url: 'ProductCompareService.svc/GetProductCompareWidgetViewModel' + '?lang=' + LhApp.Context.Language, //todo perikstath -> this should be resolved by the rewriter and be like /el/
            data: { templateCode: LhApp.Context.Item ? LhApp.Context.Item.Template : "" },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        if (widgetModel != null && widgetModel != undefined && Vendd.ProductCompare.GetClientModel() != null && document.cookie.indexOf('ForceClearCompareLocalStorage') == -1) {

            Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.GetWidgetModelSuccess(widgetModel));
            return true;
        }

        Cookies.remove('ForceClearCompareLocalStorage', { path: '/' });//clean ProductCompare cookie 
        widgetModelPending = true;

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.Add, Vendd.ProductCompare, function (envelope) {

        var data = {};
        data.item = envelope.message.data;

        var options = {
            url: 'EcomService.svc/AddToProductCompare',
            data: data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            if (response.success) {
                Vendd.ProductCompare.ClearClientModel();  
                Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.ProductCompareAdded(response));
                Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.Changed());
            }
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.Failed(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.Remove, Vendd.ProductCompare, function (envelope) {

        var options = {
            url: 'EcomService.svc/RemoveFromProductCompare',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            if (response.success) {
                Vendd.ProductCompare.ClearClientModel();
                Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.ProductCompareRemoved(response));
                Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.Changed());
            }
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.Failed(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.Clear, Vendd.ProductCompare, function (envelope) {

        var options = {
            url: 'EcomService.svc/ClearProductCompare',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            if (response.success) {
                Vendd.ProductCompare.ClearClientModel();
                Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.Changed());
            }
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ProductCompare, new Vendd.ProductCompare.Messages.Failed(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.ProductCompare.ClearClientModel = function () {
        localStorage.removeItem('CurrentCompareModel');
    };

    Vendd.ProductCompare.GetClientModel = function () {
        var mdl = JSON.parse(localStorage.getItem("CurrentCompareModel"));

        return LhApp.Function.validateClientModel(mdl)
            ? $.extend({ IsLocalStorageCache: true }, mdl)
            : null;
    };

    Vendd.ProductCompare.SetClientModel = function (widgetModel) {
        localStorage.setItem('CurrentCompareModel', JSON.stringify(widgetModel));
    };

    var model = null;
    var widgetModel = Vendd.ProductCompare.GetClientModel();

    return Vendd;

})(Vendd || {});